import { render, staticRenderFns } from "./VihkoTarkastusAsetukset.vue?vue&type=template&id=c1efbe60"
import script from "./VihkoTarkastusAsetukset.vue?vue&type=script&lang=js"
export * from "./VihkoTarkastusAsetukset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports